import { useEffect } from "react"


export const useIframeIdleDetection = () => {

  useEffect(() => {

    const inIframe = window.self !== window.top;
    if(!inIframe){
      return;
    }

    const informParent = ()=> {
      window.parent.postMessage({ type: 'user-activity' }, '*');
    }

    const events = [
      "mousemove", "mousedown", "keydown", "scroll", "touchstart", "touchmove", "wheel"
    ]

    events.forEach(event =>
      document.addEventListener(event, informParent, { passive: true })
    )

    return () => {

      events.forEach(event =>
        document.removeEventListener(event, informParent)
      )
    }

  }, []);

}